import * as React from 'react';
import { useGetShipmentQuery } from "../../../apis/Shipment.api";
import { PrimaryShipment, Shipment } from "../../../types/models/Shipment";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Shipment;
};

export const ShipmentNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.key }
                    {data?.reportKey && <> | </> }{ data?.reportKey }
                    {data?.shipmentAt && <> | </> }
                        {displayDateTime(data?.shipmentAt) }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ShipmentName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetShipmentQuery(PrimaryShipment.fromId(id))
    return (<ShipmentNameDisplay data={data}/>)
}

export default ShipmentName;
